/* prettier-ignore */

import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, inject, signal, ViewEncapsulation, WritableSignal } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { DragHandleComponent } from 'src/app/shared/drag-handle/drag-handle.component';
import { animate, style, transition, trigger } from '@angular/animations';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { GamificationService } from '../../services/gamification.service';
import { Router } from '@angular/router';

@Component({
  selector: "app-passport-add-stamp",
  imports: [
    CommonModule,
    TranslateModule,
    DragHandleComponent,
    // LottieComponent,
    ZXingScannerModule
  ],  
  standalone: true,
  animations: [
    trigger('fadeOut', [
      transition(':leave', [
        style({
          height: '*',
          opacity: 1,
          marginTop: '*',
          marginBottom: '*',
          paddingTop: '*',
          paddingBottom: '*'
        }),
        animate(
          '250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            height: 0,
            opacity: 0,
            marginTop: 0,
            marginBottom: 0,
            paddingTop: 0,
            paddingBottom: 0
          })
        )
      ])
    ]),
    trigger('fadeIn', [
      transition(':enter', [
        style({
          height: 0,
          opacity: 0,
          marginTop: 0,
          marginBottom: 0,
          paddingTop: 0,
          paddingBottom: 0
        }),
        animate(
          '250ms cubic-bezier(0.4, 0, 0.2, 1)',
          style({
            height: '*',
            opacity: 1,
            marginTop: '*',
            marginBottom: '*',
            paddingTop: '*',
            paddingBottom: '*'
          })
        )
      ]),
    ])
  ],
  templateUrl: "./add-badge.component.html",
  styleUrls: ["./add-badge.component.scss"],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  encapsulation: ViewEncapsulation.None
})

export class AddBadgeComponent {
    private bottomSheet: MatBottomSheet = inject(MatBottomSheet);
    private _gamificationService = inject(GamificationService);
    private _router = inject(Router);
    public translate = inject(TranslateService);
    public isStamping: WritableSignal<boolean> = signal<boolean>(false);
    public currentDevice: MediaDeviceInfo | undefined;
    
    protected addedBadge = this._gamificationService.addedBadge;

    public toggleStamp(){
      this.isStamping.update(prev => !prev);
    }

    public navigateToPassportsList(){
      this._gamificationService.setAddedBadge(null);
      
      /* check if the current url is already /my-account/passports, 
         reload the page to update the passport list with the new stamp, 
         if not navigate to /my-account/passports
       */
      if (this._router.url === '/my-account/passports') {
        window.location.reload();
        return;
      }
      
      this.dismissBottomSheet();
      
      this._router.navigateByUrl('/my-account/passports');
    }
    
    protected navigateToBadgeListByPassportId(id: number): void {
      this._gamificationService.setAddedBadge(null);
      
      this.dismissBottomSheet();
      
      this._router.navigate(['/my-account/passports', id, 'badges']);
    }

    public dismissBottomSheet(){
      this._gamificationService.setAddedBadge(null);
      
      this.bottomSheet.dismiss();
    }

    public onCodeResult(qrCode: string) {
      this._gamificationService.sealBadgeByQrCodeServiceSignal(qrCode);
    }
  
}
